import Profile from "./components/Profile/Profile";
import ContentSelector from "./components/Content/ContentSelector";

function App() {
  return (
    <>
      <Profile />
      <ContentSelector />
    </>
  );
}

export default App;
